"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyDatabase = exports.LegacyType = exports.LegacyTypeName = exports.LegacyRelation = exports.LegacyColumnRef = exports.LegacyTableRef = exports.LegacyRelationName = exports.LegacyTable = exports.LegacyTableDbStats = exports.LegacyColumn = exports.LegacyColumnDbStats = exports.LegacyCheck = exports.LegacyIndex = exports.LegacyUnique = exports.LegacyPrimaryKey = exports.LegacyColumnId = exports.LegacyColumnValue = exports.LegacyColumnType = exports.LegacyColumnName = exports.LegacyTableId = exports.LegacyTableName = exports.LegacySchemaName = exports.LegacyJsValue = exports.legacyColumnTypeUnknown = exports.legacyColumnPathSeparator = void 0;
exports.schemaToColumns = schemaToColumns;
exports.databaseFromLegacy = databaseFromLegacy;
exports.databaseToLegacy = databaseToLegacy;
exports.tableDbStatsFromLegacy = tableDbStatsFromLegacy;
exports.tableDbStatsToLegacy = tableDbStatsToLegacy;
exports.columnValueFromLegacy = columnValueFromLegacy;
exports.columnValueToLegacy = columnValueToLegacy;
exports.primaryKeyFromLegacy = primaryKeyFromLegacy;
exports.columnNameFromLegacy = columnNameFromLegacy;
exports.uniqueFromLegacy = uniqueFromLegacy;
exports.indexFromLegacy = indexFromLegacy;
exports.checkFromLegacy = checkFromLegacy;
exports.relationFromLegacy = relationFromLegacy;
exports.tableRefFromId = tableRefFromId;
exports.tableRefToId = tableRefToId;
exports.columnRefFromLegacy = columnRefFromLegacy;
exports.columnRefToLegacy = columnRefToLegacy;
exports.typeFromLegacy = typeFromLegacy;
exports.legacyDatabaseJsonFormat = legacyDatabaseJsonFormat;
const zod_1 = require("zod");
const utils_1 = require("@azimutt/utils");
const common_1 = require("../common");
exports.legacyColumnPathSeparator = ":";
exports.legacyColumnTypeUnknown = 'unknown';
const LegacyJsValueLiteral = zod_1.z.union([zod_1.z.string(), zod_1.z.number(), zod_1.z.boolean(), zod_1.z.date(), zod_1.z.null()]);
exports.LegacyJsValue = zod_1.z.lazy(() => zod_1.z.union([LegacyJsValueLiteral, zod_1.z.array(exports.LegacyJsValue), zod_1.z.record(exports.LegacyJsValue)]));
exports.LegacySchemaName = zod_1.z.string();
exports.LegacyTableName = zod_1.z.string();
exports.LegacyTableId = zod_1.z.string();
exports.LegacyColumnName = zod_1.z.string();
exports.LegacyColumnType = zod_1.z.string();
exports.LegacyColumnValue = zod_1.z.string();
exports.LegacyColumnId = zod_1.z.string();
exports.LegacyPrimaryKey = zod_1.z.object({ name: zod_1.z.string().nullish(), columns: exports.LegacyColumnName.array() }).strict();
exports.LegacyUnique = zod_1.z.object({
    name: zod_1.z.string().nullish(),
    columns: exports.LegacyColumnName.array(),
    definition: zod_1.z.string().nullish()
}).strict();
exports.LegacyIndex = zod_1.z.object({
    name: zod_1.z.string().nullish(),
    columns: exports.LegacyColumnName.array(),
    definition: zod_1.z.string().nullish()
}).strict();
exports.LegacyCheck = zod_1.z.object({
    name: zod_1.z.string().nullish(),
    columns: exports.LegacyColumnName.array(),
    predicate: zod_1.z.string().nullish()
}).strict();
exports.LegacyColumnDbStats = zod_1.z.object({
    nulls: zod_1.z.number().optional(), // percentage of nulls
    bytesAvg: zod_1.z.number().optional(), // average bytes for a value
    cardinality: zod_1.z.number().optional(), // number of different values
    commonValues: zod_1.z.object({
        value: exports.LegacyColumnValue,
        freq: zod_1.z.number()
    }).strict().array().optional(),
    histogram: exports.LegacyColumnValue.array().optional(),
}).strict();
exports.LegacyColumn = zod_1.z.object({
    name: exports.LegacyColumnName,
    type: exports.LegacyColumnType,
    nullable: zod_1.z.boolean().nullish(),
    default: exports.LegacyColumnValue.nullish(),
    comment: zod_1.z.string().nullish(),
    values: zod_1.z.string().array().nullish(),
    columns: zod_1.z.lazy(() => exports.LegacyColumn.array().nullish()),
    stats: exports.LegacyColumnDbStats.nullish()
}).strict();
exports.LegacyTableDbStats = zod_1.z.object({
    rows: zod_1.z.number().optional(), // number of rows
    size: zod_1.z.number().optional(), // used bytes
    sizeIdx: zod_1.z.number().optional(), // used bytes for indexes
    scanSeq: zod_1.z.number().optional(), // number of seq scan
    scanSeqLast: common_1.DateTime.optional(),
    scanIdx: zod_1.z.number().optional(), // number of index scan
    scanIdxLast: common_1.DateTime.optional(),
    analyzeLast: common_1.DateTime.optional(),
    vacuumLast: common_1.DateTime.optional(),
}).strict();
exports.LegacyTable = zod_1.z.object({
    schema: exports.LegacySchemaName,
    table: exports.LegacyTableName,
    columns: exports.LegacyColumn.array(),
    view: zod_1.z.boolean().nullish(),
    definition: zod_1.z.string().nullish(), // query definition for views
    primaryKey: exports.LegacyPrimaryKey.nullish(),
    uniques: exports.LegacyUnique.array().nullish(),
    indexes: exports.LegacyIndex.array().nullish(),
    checks: exports.LegacyCheck.array().nullish(),
    comment: zod_1.z.string().nullish(),
    stats: exports.LegacyTableDbStats.nullish(),
}).strict();
exports.LegacyRelationName = zod_1.z.string();
exports.LegacyTableRef = zod_1.z.object({
    schema: exports.LegacySchemaName,
    table: exports.LegacyTableName,
}).strict();
exports.LegacyColumnRef = zod_1.z.object({
    table: exports.LegacyTableId,
    column: exports.LegacyColumnName
}).strict();
exports.LegacyRelation = zod_1.z.object({ name: exports.LegacyRelationName, src: exports.LegacyColumnRef, ref: exports.LegacyColumnRef }).strict();
const LegacyTypeContent = zod_1.z.union([
    zod_1.z.object({ values: zod_1.z.string().array().nullable() }),
    zod_1.z.object({ definition: zod_1.z.string() })
]);
exports.LegacyTypeName = zod_1.z.string();
exports.LegacyType = zod_1.z.object({
    schema: exports.LegacySchemaName,
    name: exports.LegacyTypeName
}).and(LegacyTypeContent);
exports.LegacyDatabase = zod_1.z.object({
    tables: exports.LegacyTable.array(),
    relations: exports.LegacyRelation.array(),
    types: exports.LegacyType.array().nullish()
}).strict().describe('LegacyDatabase');
function schemaToColumns(schema, flatten, path = []) {
    // TODO: if string with few values (< 10% of docs), handle it like an enum and add values in comment
    if (schema.nested && flatten > 0) {
        return Object.entries(schema.nested).flatMap(([key, value]) => {
            return [{
                    name: path.map(p => p + '.').join('') + key,
                    type: value.type,
                    nullable: value.nullable
                }, ...schemaToColumns(value, flatten - 1, [...path, key])];
        });
    }
    else if (schema.nested) {
        return Object.entries(schema.nested).map(([key, value]) => {
            return (0, utils_1.removeUndefined)({
                name: path.map(p => p + '.').join('') + key,
                type: value.type,
                nullable: value.nullable,
                columns: value.nested ? schemaToColumns(value, 0, []) : undefined
            });
        });
    }
    else {
        return [];
    }
}
function databaseFromLegacy(db) {
    return (0, utils_1.removeEmpty)({
        entities: db.tables.map(tableFromLegacy),
        relations: db.relations.map(relationFromLegacy),
        types: db.types?.map(typeFromLegacy)
    });
}
function databaseToLegacy(db) {
    return (0, utils_1.removeUndefined)({
        tables: db.entities?.map(tableToLegacy) || [],
        relations: db.relations?.flatMap(relationToLegacy) || [],
        types: db.types?.map(typeToLegacy)
    });
}
function tableFromLegacy(t) {
    return (0, utils_1.removeEmpty)({
        database: undefined,
        catalog: undefined,
        schema: t.schema || undefined,
        name: t.table,
        kind: t.view ? 'view' : undefined,
        def: t.definition || undefined,
        attrs: t.columns.map(columnFromLegacy),
        pk: t.primaryKey ? primaryKeyFromLegacy(t.primaryKey) : undefined,
        indexes: (t.uniques || []).map(uniqueFromLegacy).concat((t.indexes || []).map(indexFromLegacy)),
        checks: t.checks?.map(checkFromLegacy),
        doc: t.comment || undefined,
        stats: t.stats ? tableDbStatsFromLegacy(t.stats) : undefined,
    });
}
function tableToLegacy(e) {
    const uniques = e.indexes?.filter(i => i.unique) || [];
    const indexes = e.indexes?.filter(i => !i.unique) || [];
    return (0, utils_1.removeUndefined)({
        schema: e.schema || '',
        table: e.name,
        columns: (e.attrs || []).map(columnToLegacy),
        view: e.kind === 'view' || e.kind === 'materialized view' || undefined,
        definition: e.def,
        primaryKey: e.pk ? primaryKeyToLegacy(e.pk) : undefined,
        uniques: uniques.length > 0 ? uniques.map(uniqueToLegacy) : undefined,
        indexes: indexes.length > 0 ? indexes.map(indexToLegacy) : undefined,
        checks: e.checks ? e.checks.map(checkToLegacy) : undefined,
        comment: e.doc,
        stats: e.stats ? tableDbStatsToLegacy(e.stats) : undefined,
    });
}
function tableDbStatsFromLegacy(s) {
    return (0, utils_1.removeUndefined)({
        rows: s.rows,
        size: s.size,
        sizeIdx: s.sizeIdx,
        scanSeq: s.scanSeq,
        scanSeqLast: s.scanSeqLast,
        scanIdx: s.scanIdx,
        scanIdxLast: s.scanIdxLast,
        analyzeLast: s.analyzeLast,
        vacuumLast: s.vacuumLast,
    });
}
function tableDbStatsToLegacy(s) {
    return (0, utils_1.removeUndefined)({
        rows: s.rows,
        size: s.size,
        sizeIdx: s.sizeIdx,
        scanSeq: s.scanSeq,
        scanSeqLast: s.scanSeqLast,
        scanIdx: s.scanIdx,
        scanIdxLast: s.scanIdxLast,
        analyzeLast: s.analyzeLast,
        vacuumLast: s.vacuumLast,
    });
}
function columnFromLegacy(c) {
    return (0, utils_1.removeUndefined)({
        name: c.name,
        type: c.type,
        null: c.nullable || undefined,
        default: c.default ? columnValueFromLegacy(c.default) : undefined,
        attrs: c.columns ? c.columns.map(columnFromLegacy) : undefined,
        doc: c.comment || undefined,
        stats: c.stats || c.values ? (0, utils_1.removeUndefined)({
            nulls: c.stats?.nulls,
            bytesAvg: c.stats?.bytesAvg,
            cardinality: c.stats?.cardinality,
            commonValues: c.stats?.commonValues?.map(v => ({ value: columnValueFromLegacy(v.value), freq: v.freq })),
            distinctValues: c.values?.map(columnValueFromLegacy),
            histogram: c.stats?.histogram?.map(columnValueFromLegacy),
            min: undefined,
            max: undefined,
        }) : undefined,
    });
}
function columnToLegacy(a) {
    return (0, utils_1.removeEmpty)({
        name: a.name,
        type: a.type,
        nullable: a.null,
        default: a.default ? columnValueToLegacy(a.default) : undefined,
        comment: a.doc,
        values: a.stats?.distinctValues?.map(columnValueToLegacy),
        columns: a.attrs?.map(columnToLegacy),
        stats: a.stats ? (0, utils_1.removeUndefined)({
            nulls: a.stats.nulls,
            bytesAvg: a.stats.bytesAvg,
            cardinality: a.stats.cardinality,
            commonValues: a.stats.commonValues?.map(v => ({ value: columnValueToLegacy(v.value), freq: v.freq })),
            histogram: a.stats.histogram?.map(columnValueToLegacy),
        }) : undefined,
    });
}
function columnValueFromLegacy(v) {
    return v;
}
function columnValueToLegacy(v) {
    if (v === undefined)
        return 'null';
    if (v === null)
        return 'null';
    if (typeof v === 'object')
        return JSON.stringify(v);
    return v.toString(); // TODO: improve?
}
function primaryKeyFromLegacy(pk) {
    return (0, utils_1.removeUndefined)({
        name: pk.name || undefined,
        attrs: pk.columns.map(columnNameFromLegacy)
    });
}
function primaryKeyToLegacy(pk) {
    return (0, utils_1.removeUndefined)({
        name: pk.name,
        columns: pk.attrs.map(columnNameToLegacy)
    });
}
function columnNameFromLegacy(n) {
    return n.split(exports.legacyColumnPathSeparator);
}
function columnNameToLegacy(p) {
    return p.join(exports.legacyColumnPathSeparator);
}
function uniqueFromLegacy(u) {
    return (0, utils_1.removeUndefined)({
        name: u.name || undefined,
        attrs: u.columns.map(columnNameFromLegacy),
        unique: true,
        definition: u.definition || undefined,
    });
}
function uniqueToLegacy(i) {
    return (0, utils_1.removeUndefined)({
        name: i.name,
        columns: i.attrs.map(columnNameToLegacy),
        definition: i.definition
    });
}
function indexFromLegacy(i) {
    return (0, utils_1.removeUndefined)({
        name: i.name || undefined,
        attrs: i.columns.map(columnNameFromLegacy),
        definition: i.definition || undefined,
    });
}
function indexToLegacy(i) {
    return (0, utils_1.removeUndefined)({
        name: i.name,
        columns: i.attrs.map(columnNameToLegacy),
        definition: i.definition
    });
}
function checkFromLegacy(c) {
    return (0, utils_1.removeUndefined)({
        name: c.name || undefined,
        attrs: c.columns.map(columnNameFromLegacy),
        predicate: c.predicate || '',
    });
}
function checkToLegacy(c) {
    return (0, utils_1.removeUndefined)({
        name: c.name,
        columns: c.attrs.map(columnNameToLegacy),
        predicate: c.predicate || undefined
    });
}
function relationFromLegacy(r) {
    return (0, utils_1.removeUndefined)({
        name: r.name || undefined,
        src: { ...columnRefFromLegacy2(r.src), attrs: [r.src.column.split(exports.legacyColumnPathSeparator)] },
        ref: { ...columnRefFromLegacy2(r.ref), attrs: [r.ref.column.split(exports.legacyColumnPathSeparator)] },
    });
}
function relationToLegacy(r) {
    return (0, utils_1.zip)(r.src.attrs, r.ref.attrs).map(([srcAttr, refAttr]) => ({ name: r.name || '', src: columnRefToLegacy2(r.src, srcAttr), ref: columnRefToLegacy2(r.ref, refAttr) }));
}
function tableRefFromId(id) {
    const [schema, table] = id.split('.');
    return table ? { schema, table } : { schema: '', table: schema };
}
function tableRefToId(ref) {
    return `${ref.schema}.${ref.table}`;
}
function columnRefFromLegacy(c) {
    // FIXME: use function from ColumnName to AttributePath
    const { schema, table } = tableRefFromId(c.table);
    return (0, utils_1.removeUndefined)({ schema: schema || undefined, entity: table, attribute: [c.column] });
}
function columnRefToLegacy(a) {
    // FIXME: use function from AttributePath to ColumnName
    return { table: tableRefToId({ schema: a.schema || '', table: a.entity }), column: a.attribute.join(exports.legacyColumnPathSeparator) };
}
function columnRefFromLegacy2(e) {
    const { schema, table } = tableRefFromId(e.table);
    return (0, utils_1.removeUndefined)({ schema: schema || undefined, entity: table });
}
function columnRefToLegacy2(e, c) {
    return { table: tableRefToId({ schema: e.schema || '', table: e.entity }), column: c.join(exports.legacyColumnPathSeparator) };
}
function typeFromLegacy(t) {
    if ('values' in t) {
        return (0, utils_1.removeUndefined)({ schema: t.schema || undefined, name: t.name, values: t.values || undefined });
    }
    else {
        return (0, utils_1.removeUndefined)({ schema: t.schema || undefined, name: t.name, definition: t.definition });
    }
}
function typeToLegacy(t) {
    if (t.values) {
        return { schema: t.schema || '', name: t.name, values: t.values };
    }
    else {
        return { schema: t.schema || '', name: t.name, definition: t.definition || '' };
    }
}
function legacyDatabaseJsonFormat(database) {
    return (0, utils_1.stringify)(database, (path, value) => {
        const last = path[path.length - 1];
        // if (last === 'tables' || last === 'relations' || last === 'types') return 0
        if (path.includes('columns') && last !== 'columns')
            return 0;
        if (path.includes('primaryKey'))
            return 0;
        if (path.includes('uniques') && path.length > 3)
            return 0;
        if (path.includes('indexes') && path.length > 3)
            return 0;
        if (path.includes('checks') && path.length > 3)
            return 0;
        if (path.includes('relations') && path.length > 2)
            return 0;
        if (path.includes('types') && path.length > 1)
            return 0;
        return 2;
    });
}
//# sourceMappingURL=legacyDatabase.js.map